module.exports = __webpack_public_path__ + "static/media/goto-race-room.d40fad0c.mp3";